import { render } from "./TemplateDbsDetail.vue?vue&type=template&id=407ee191&scoped=true"
import script from "./TemplateDbsDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDbsDetail.vue?vue&type=script&lang=js"

import "./TemplateDbsDetail.vue?vue&type=style&index=0&id=407ee191&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-407ee191"

export default script